import { render, staticRenderFns } from "./ValidationWorkOrders.vue?vue&type=template&id=0022ec50&"
import script from "./ValidationWorkOrders.vue?vue&type=script&lang=js&"
export * from "./ValidationWorkOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports